import * as React from "react"

const SvgDeviceLaptop = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M1 20.571a.97.97 0 0 1-.713-.287A.97.97 0 0 1 0 19.57a.97.97 0 0 1 .287-.712A.97.97 0 0 1 1 18.57h3v-1q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 15.57v-10q0-.824.587-1.412A1.93 1.93 0 0 1 4 3.57h16q.824 0 1.413.588Q22 4.746 22 5.57v10a1.93 1.93 0 0 1-.587 1.413A1.93 1.93 0 0 1 20 17.57v1h3q.424 0 .712.288.288.289.288.712a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287H1Zm3-5h16v-10H4z" />
  </svg>
)
export default SvgDeviceLaptop
